const ITEMS = [
  "MARY MACHINEGUN",
  "NINJA BIMBOS",
  "HUMAN HUNTERS",
  "DARK AMERICA",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="relative border-y-4 border-blooddeep bg-pulp py-4 overflow-hidden -rotate-1 scale-[1.02] my-4">
      <div className="animate-marquee flex whitespace-nowrap will-change-transform">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-impact uppercase tracking-widest text-lg sm:text-xl text-paper/85 px-6">
                  {item}
                </span>
                <span className="text-crimson text-lg">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
